angular.module('charts')
    .directive('dblStatusIndicator', function() {
        return {
            restrict: 'E',
            scope: {
                dblStatus: '='
            },
            templateUrl: '/resources/charts/directives/status-indicator/dbl-status-indicator.directive.html',
            link: function(scope, element) {
                scope.$watch('dblStatus', function (newVal) {
                    if (!newVal) {
                        scope.warn = false;
                        scope.congratulate = false;
                        return;
                    }

                    switch (newVal) {
                        case 1: // congratulate
                            scope.warn = false;
                            scope.congratulate = true;

                            break;
                        case 2: // warn
                            scope.warn = true;
                            scope.congratulate = false;

                            break;
                    }
                });
            }
        };
    });
